export default __webpack_public_path__ + "images/logoInnovation.8ea87dec6ec181aee8a5c9b83f03744b.svg"